'use client';

import { useState } from 'react';
import { installDocumentBodyGuard } from '../../utils/documentBodyGuard';

/**
 * Installs the `document.body` fallback (see `documentBodyGuard.ts`) on the
 * first client render, from the root layout. Same lazy-`useState`
 * once-per-mount pattern as `DomMutationGuard`. No-ops on the server and on
 * repeat calls.
 */
export const DocumentBodyGuard = () => {
  useState(() => {
    installDocumentBodyGuard();
    return null;
  });
  return null;
};
